// extracted by mini-css-extract-plugin
export default {"starter":"AchievedGoalsList_starter__Dzdwj","achieved-goal-list":"AchievedGoalsList_achieved-goal-list__BGzQJ","ok":"AchievedGoalsList_ok__W16In"};